/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminNBClassifierService {

  constructor(private http: HttpClient) { }

  getNBTraining(type:string, language: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/nbclassifier/training/${type}/${language}`
      );
  }

  newTraining(type: string, content: string, language: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/nbclassifier/training`,
        JSON.stringify({ type: type, content: content, lang: language })
      );
  }

  updateTraining(id: string, content: string, language: string): Observable<any> {
    return this.http
      .put(
        `/api/v1/admin/nbclassifier/training/${id}`,
        JSON.stringify({ content: content, lang: language })
      );
  }

  deleteTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/nbclassifier/training/${id}`
      );
  }

  classify(edId: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/nbclassifier/classify/${edId}`
      );
  }

  classifyEmail(customerEmail: any, emailDetail: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/pipeline/email`,
        { customerEmail: customerEmail, emailDetail: emailDetail }
      );
  }

  getWordmap(type:string, language: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/nbclassifier/wordmap/${type}/${language}`
      );
  }

  newStopword(content: string, language: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/nbclassifier/stopword`,
        JSON.stringify({ content: content, lang: language })
      );
  }

  deleteStopword(word: string, language: string): Observable<any> {
    return this.http
      .put(
        `/api/v1/admin/nbclassifier/stopword`,
        JSON.stringify({ word: word, lang: language})
      );
  }
}


// WEBPACK FOOTER //
// ./client/app/services/admin/admin-nbclassifier.service.ts